import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openModal } from 'base/actions/modal';

/**
 * This is a renderless component that will determine if a modal.
 */
class LocationModalManager extends React.Component {
  static propTypes = {
    shouldOpenEditCartItemModal: PropTypes.bool,
    dispatch: PropTypes.func
  };

  componentDidMount() {
    this.renderModal();
  }

  renderModal = () => {
    const { shouldOpenEditCartItemModal, dispatch } = this.props;

    if (shouldOpenEditCartItemModal) {
      dispatch(openModal());
    }
  };

  render() {
    return null;
  }
}

export default connect()(LocationModalManager);
